// CardGuidance.translations.ts
export default {
  grade9: {
    id: 'product_jp_product_condition_switcher_grade_9',
    defaultMessage: 'Premium is',
  },
  grade10: {
    id: 'product_jp_product_condition_switcher_grade_10',
    defaultMessage: 'A grade (Excellent) is',
  },
  grade11: {
    id: 'product_jp_product_condition_switcher_grade_11',
    defaultMessage: 'B grade (Good) is',
  },
  grade12: {
    id: 'product_jp_product_condition_switcher_grade_12',
    defaultMessage: 'C grade (Fair) is',
  },
  screenDescription9: {
    id: 'product_jp_product_condition_screen_carousel_premium_content',
    defaultMessage: 'No scratch.',
  },
  screenDescription10: {
    id: 'product_jp_product_condition_screen_carousel_grade_a_content',
    defaultMessage: 'No scratch.',
  },
  screenDescription11: {
    id: 'product_jp_product_condition_screen_carousel_grade_b_content',
    defaultMessage: 'No scratch.',
  },
  screenDescription12: {
    id: 'product_jp_product_condition_screen_carousel_grade_c_content',
    defaultMessage:
      'There are some light scratches that are not visible when the power is turned on.',
  },
  bodyDescription9: {
    id: 'product_jp_product_condition_body_carousel_premium_content',
    defaultMessage: 'Best quality product available on Back Market.',
  },
  bodyDescription10: {
    id: 'product_jp_product_condition_body_carousel_grade_a_content',
    defaultMessage:
      'There may be slight scratches that are barely visible from a distance of 20cm.',
  },
  bodyDescription11: {
    id: 'product_jp_product_condition_body_carousel_grade_b_content',
    defaultMessage:
      'There are minor scratches that are only visible from a distance of 50cm.',
  },
  bodyDescription12: {
    id: 'product_jp_product_condition_body_carousel_grade_c_content',
    defaultMessage:
      "There are scratches and dents visible from a distance of 50cm, but they don't affect the functionality.",
  },
  body: {
    id: 'product_jp_product_condition_switcher_body',
    defaultMessage: 'Body',
  },
  screen: {
    id: 'product_jp_product_condition_switcher_screen',
    defaultMessage: 'Screen',
  },
  battery: {
    id: 'product_jp_product_condition_switcher_battery',
    defaultMessage: 'Battery',
  },
  batteryDescription9: {
    id: 'product_jp_product_condition_battery_carousel_premium_content',
    defaultMessage: '90~100% battery capacity guarantee.',
  },
  batteryDescription10: {
    id: 'product_jp_product_condition_battery_carousel_grade_a_content',
    defaultMessage: '80~100% battery capacity guarantee.',
  },
  batteryDescription11: {
    id: 'product_jp_product_condition_battery_carousel_grade_b_content',
    defaultMessage: '80~100% battery capacity guarantee.',
  },
  batteryDescription12: {
    id: 'product_jp_product_condition_battery_carousel_grade_c_content',
    defaultMessage: '80~100% battery capacity guarantee.',
  },
  smartphoneSwitcherContent9: {
    id: 'product_jp_product_condition_switcher_premium_smartphones_content',
    defaultMessage:
      'Screen: No scratch.\nBattery: 100% battery capacity guarantee.\nBody: Best quality product available on Back Market.',
  },
}
